export const validateForm = (formData) => {
  let errors = {};
  if (!formData.restaurantId)
    errors.restaurantId = "Swiggy Restaurant ID is required";
  if (!formData.restaurantName)
    errors.restaurantName = "Restaurant Name is required";
  if (!formData.emailAddress) {
    errors.emailAddress = "Email address is required";
  } else if (
    !/^[^\s@]+@[^\s@]+\.[^\s@.]+$/.test(formData.emailAddress) ||
    formData.emailAddress.includes("..")
  ) {
    errors.emailAddress = "Invalid email format";
  }
  if (!formData.contactNo) {
    errors.contactNo = "Phone number is required";
  } else if (!/^[0-9]{10}$/.test(formData.contactNo)) {
    errors.contactNo = "Phone number must be exactly 10 digits";
  }
  return errors;
};
